var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"accept":_vm.accept,"multiple":_vm.multiple,"limit":_vm.limit,"show-file-list":false,"action":"uploadImgUrl","before-upload":_vm.handleBeforeUpload,"http-request":_vm.handleUpload,"on-exceed":_vm.handleExceed,"on-change":_vm.handleChange}},[_c('div',{staticClass:"uploadCellimg",style:({
        width: `${_vm.width}px`,
        height: `${_vm.height}px`,
      })},[_c('i',{staticClass:"el-icon-plus"}),_c('span',[_vm._v(_vm._s(_vm.tip))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }